<div *ngIf='screenWidth > 767'>
  <div class="flex"></div>
  <div class="flex-444-px">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Account Recovery</div>
      <form [formGroup]='userForm' (ngSubmit)="onSubmit()">
        <label for="email">Recovery Email</label>
        <br>
        <input type="text" placeholder="someone@example.com" name="email" id="email" [formControl]="email">
        <!-- <i [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[10]=true'
          *ngIf='!toggleEditStyles[10]'>edit</i> -->
        <br>
        <label for="phone">Recovery Phone</label>
        <br>
        <input type="text" placeholder="(___) ___-____" [imask]="phoneMask" name="phone" id="phone" [formControl]="phone">
        <!-- <i [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[9]=true'
          *ngIf='!toggleEditStyles[9]'>edit</i> -->
        <br>
        <button type='submit' [disabled]='userForm.invalid' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-submit-button"
          style="padding:7px;margin-top:70px">Update Recovery Info</button>
      </form>
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div class="bmw-profile-content bmw-xs">
      <div class="bmw-user-info-title">Personal Info</div>
      <form [formGroup]='userForm' (ngSubmit)="onSubmit()">
        <label for="email">Recovery Email</label>
        <br>
        <input type="text" placeholder="someone@example.com" name="email" id="email" [formControl]="email" [ngClass]='{"bmw-active-input": toggleEditStyles[10]}'
          (focusout)='toggleEditStyles[10]=false' [readOnly]='!toggleEditStyles[10]'>
        <i [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[10]=true'
          *ngIf='!toggleEditStyles[10]'>edit</i>
        <br>
        <label for="phone">Recovery Phone</label>
        <br>
        <input type="text" placeholder="(___) ___-____" [imask]="phoneMask" name="phone" id="phone" [formControl]="phone" [ngClass]='{"bmw-active-input": toggleEditStyles[9]}'
          (focusout)='toggleEditStyles[9]=false' [readOnly]='!toggleEditStyles[9]'>
        <i [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="material-icons pointer" (click)='toggleEditStyles[9]=true'
          *ngIf='!toggleEditStyles[9]'>edit</i>
        <br>
        <button type='submit' class="bmw-submit-button" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
          style="padding:7px;margin-top:70px">Update Recovery Info</button>
      </form>
      <div [routerLink]='["/profile"]' class="bmw-button-secondary bmw-xs pointer">Back</div>
    </div>
  </div>
</div>
